import "./ExploreEmployees.css";
import employee from "../../assets/employee.png";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import { useState } from "react";
import { useContactUsMutation } from "../../store/query/auth";

const ExploreEmployees = ({ title, input, children, para, subpara }) => {
  const [contactUs, { isLoading, isSuccess, error }] = useContactUsMutation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    comment: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await contactUs(formData).unwrap();
      setFormData({ name: "", email: "", comment: "" }); // reset form
    } catch (err) {
      console.error("Contact us error:", err);
    }
  };

  return (
    <div className="explore-employees-container">
      <div className="explore-employee-image" data-aos="fade-right">
        <img src={employee} alt="" />
      </div>

      <div className="explore-employee-content" data-aos="fade-left">
        <h2>{title}</h2>
        <p className="explore-text">
          {para
            ? para
            : "With our team of innovative healthcare practitioners and IT personnels, we could offer a solution tailored to your heathcare facility/organization workforce needs. Kindly enter your email below to get started."}
        </p>

        {subpara && (
          <p className="explore-text" style={{ fontWeight: 700 }}>
            {subpara}
          </p>
        )}

        {input && (
          <div className="explore-employee-search-box">
            <form className="employee-form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                placeholder="Message"
                name="comment"
                value={formData.comment}
                onChange={handleChange}
                required
              ></textarea>
              <div className="btn-bg">
                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Sending..." : "Submit"}{" "}
                  <FaRegArrowAltCircleRight />
                </button>
              </div>
            </form>

            {/* ✅ Show response messages */}
            {isSuccess && (
              <p style={{ color: "green" }} className="success-text">
                Message sent successfully 🎉
              </p>
            )}
            {error && (
              <p style={{ color: "red" }} className="error-text">
                Something went wrong. Try again.
              </p>
            )}
          </div>
        )}

        {children && children}
      </div>
    </div>
  );
};

export default ExploreEmployees;
